export default __webpack_public_path__ + "8dcce754f07edd46ffc8158985de04d8.svg";